export default __webpack_public_path__ + "static/media/115t.f625cab2.jpg";